var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0673 8.21994H9.75466V1.90724C9.75466 1.47949 9.40793 1.1333 8.98066 1.1333C8.55345 1.1333 8.20667 1.47949 8.20667 1.90724V8.21994H1.89397C1.46676 8.21994 1.12 8.56672 1.12 8.99393C1.12 9.42174 1.46676 9.76797 1.89397 9.76797H8.20667V16.0806C8.20667 16.5084 8.55345 16.8546 8.98066 16.8546C9.40793 16.8546 9.75466 16.5084 9.75466 16.0806V9.76797H16.0673C16.4946 9.76797 16.8413 9.42174 16.8413 8.99393C16.8413 8.56672 16.4946 8.21994 16.0673 8.21994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlus);
export default __webpack_public_path__ + "static/media/ic_plus.65673755ca99a5a4f0381cef0e60d4d4.svg";
export { ForwardRef as ReactComponent };